<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <div>
    <mat-form-field class="full-width">
      <mat-select placeholder="Select format" [(ngModel)]="format" name="format" required>
        <mat-option [value]="'csv'">CSV</mat-option>
        <!--<mat-option [value]="'pdf'">PDF</mat-option>-->
      </mat-select>
    </mat-form-field>
  </div>

  <div>

      <app-date-edit class="date-field" placeholder="From date" #startDateFilter="ngModel" [(ngModel)]="from"></app-date-edit>

  </div>
  <div>

      <app-date-edit class="date-field" placeholder="To date" #startDateFilter="ngModel" [(ngModel)]="to"></app-date-edit>

  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="to < from">Download</button>
</div>

